module.exports = __webpack_public_path__ + "InterstateWGL-Italic.d36ae59943e26325bb9b.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Italic.woff2
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Italic.woff2
// module chunks = styles